<template>
  <div>
    <div v-if="items != null">
      <h4 class="ml-1 pl-2 font-weight-bolder">Vacinas Solicitadas</h4>
      <hr>
      <b-table-lite responsive :items="items" :fields="fields">
        <template #cell(vacina)="data">
          <strong>{{ data.item.vacina }}</strong> <br />
          <b-badge
          class="mt-25 price-range-badge px-1"
          :style="{ backgroundColor: getBadgeColor(data.item.quantidadeInicial, data.item.quantidadeFinal) }"
          >
            {{ getBadgeName(data.item.quantidadeInicial) }} ({{ data.item.quantidadeFinal === null ? 'Acima de 10.000 doses e Região Sul' : `${formatNumber(data.item.quantidadeInicial)} a ${formatNumber(data.item.quantidadeFinal)} doses` }})
          </b-badge>
        </template>

        <template #cell(valorDose)="data">
          <strong class="text-primary">{{ formatCurrency(data.item.valorDoseRaw) }}</strong>
        </template>

        <template #cell(valorTotal)="data">
          <strong class="text-primary">{{ formatCurrency(data.item.valorTotalRaw) }}</strong>
        </template>
      </b-table-lite>
    </div>

    <b-card-body class="order-details-padding pb-0 mb-2" v-if="getTotals && getSumTotalQtd">
      <div class="order-totals">
        <p>Quantidade total:</p>

        <p class="order-totals-value mr-2">
          {{ getSumTotalQtd }} doses
        </p>

        <p>Total:</p>

        <p class="order-totals-value">
          {{ getTotals }}
        </p>

      </div>
    </b-card-body>

    <div class="buttons-export d-flex justify-content-end mt-2 gap-2 mr-3">
      <b-button variant="primary" class="mr-2" @click="exportarPDF">
        <feather-icon icon="PrinterIcon" size="15" />
        Exportar PDF
      </b-button>

      <b-button variant="primary" @click="exportarExcel">
        <feather-icon icon="BarChart2Icon" size="15" />
        Exportar Excel
      </b-button>
    </div>
  </div>
</template>

<script>
import { BTableLite, BCardBody, BCardText, BButton, BBadge } from 'bootstrap-vue'

export default {
  name: 'VacinasSolicitadas',
  components: {
    BTableLite,
    BCardBody,
    BCardText,
    BButton,
    BBadge
  },
  props: {
    doses: {
      type: Array,
      required: true
    },
    info: {
      type: Object,
      required: true
    },
    getTotals: {
      type: String,
      required: false
    },
    getSumTotalQtd: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      fields: [
        { key: 'vacina', label: 'VACINA | FAIXA' },
        { key: 'valorDose', label: 'VALOR DA DOSE' },
        { key: 'qtdDoses', label: 'QTD DE DOSES' },
        { key: 'valorTotal', label: 'VALOR TOTAL' }
      ]
    }
  },
  computed: {
    items() {
      if (!this.doses) return []
      
      return this.doses.map(vacina => ({
        vacina: vacina.vacina_nome_tecnico,
        faixa: vacina.nome_categoria,
        valorDoseRaw: vacina.valor / vacina.qtd_distribuida,
        qtdDoses: this.formatNumber(vacina.qtd_distribuida || 0),
        valorTotalRaw: vacina.valor,
        quantidadeInicial: vacina.quantidade_inicial,
        quantidadeFinal: vacina.quantidade_final
      }))
    }
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(value)
    },
    formatNumber(value) {
      return new Intl.NumberFormat('pt-BR').format(value)
    },
    getBadgeColor(inicial) {
      if (inicial <= 1000) return '#1f5aa5'
      if (inicial <= 2000) return '#1f5aa5'
      if (inicial <= 3000) return '#2da74d'
      if (inicial <= 5000) return '#2da74d'
      if (inicial <= 10000) return '#6e43bd'
      return '#6e43bd'
    },
    getBadgeName(inicial) {
      if (inicial <= 1000) return 'Faixa 1'
      if (inicial <= 2000) return 'Faixa 2'
      if (inicial <= 3000) return 'Faixa 3'
      if (inicial <= 5000) return 'Faixa 4'
      if (inicial <= 10000) return 'Faixa 5'
      return 'Faixa 6'
    },
    exportarPDF() {
      window.print()
    },
    exportarExcel() {
      const dadosExcel = this.items.map(item => ({
        'VACINA': item.vacina,
        'FAIXA': item.quantidadeFinal === null ? `${this.getBadgeName(item.quantidadeInicial)} (Acima de 10.000 doses e Região Sul)` : `${this.getBadgeName(item.quantidadeInicial)} (${this.formatNumber(item.quantidadeInicial)} a ${this.formatNumber(item.quantidadeFinal)} doses)`,

        'VALOR DA DOSE': this.formatCurrency(item.valorDoseRaw),
        'QTD DE DOSES': item.qtdDoses,
        'VALOR TOTAL': this.formatCurrency(item.valorTotalRaw),
        'EMPRESA': `${this.info.empresa.nome_empresa} (${this.formatDocument(this.info. empresa.documento)})`,
        'ENDEREÇO': this.getFormattedAddress(),
        'UNIDADE': this.info.sesi_responsavel?.descricao || ''
      }))
      this.$helpers.downloadArchiveXlsx(dadosExcel, 'vacinas-faixas-precos.xlsx')
    },
    formatDocument(documento) {
      if (!documento) return ''
      if (documento.length === 11) {
        return documento.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
      }
      return documento.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    },
    getFormattedAddress() {
      const endereco = this.info.adesao
      if (!endereco) return ''
      
      const { logradouro, numero, bairro } = endereco
      const cidade = this.info.nome_cidade
      const uf = this.info.uf
      
      return `${logradouro}, ${numero} - ${bairro}, ${cidade}/${uf}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "@/views/custom-pages/adesao/Details/style.scss";


.price-range-badge{
  font-size: 1rem;
}

.order-details-padding {
  padding: 1rem;
}

.order-totals {
  display: flex;
  align-items: center;
}

.order-totals p {
  margin-bottom: 0;
}

.order-totals-value {
  font-weight: bold;
  margin-right: 1rem;
}
</style>

<style lang="scss">
@media print {
  .main-menu {
    display: none;
  }
  .content-header{
    display: none;
  }
  .buttons-export{
    display: none!important;
  }
  .invoice-actions{
    display: none!important;
  }
  .price-range-badge {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    border: none!important;
  }
}
</style>